import { Component, inject, input, output, computed, type InputSignal, type OutputEmitterRef, type Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';

import { IconComponent } from '../../../icon/icon.component';
import { IconButtonComponent } from '../../../icon-button/icon-button.component';
import { FocusDirective } from '../../../focus/focus.directive';
import { ModalCloseDirective } from '../modal-close/modal-close-button.directive';
import { Breakpoint, MediaQueryService } from '../../../../services/media-query.service';
import { MODAL_HEADER_CONFIG, ModalCloseReason, ModalHeaderType } from '../../modal.domain';

import type { IconButtonBackground } from '../../../icon-button/icon-button.component';
import type { BreakpointState } from '../../../../services/media-query.service';

@Component({
  selector: 'td-wb-modal-close-button',
  templateUrl: 'modal-header-close-button.component.html',
  styleUrls: ['modal-header-close-button.component.scss'],
  imports: [ModalCloseDirective, IconComponent, IconButtonComponent, FocusDirective, TranslatePipe]
})
export class ModalHeaderCloseButtonComponent {
  readonly ariaLabel: InputSignal<string> = input<string>('tdWb.modalHeader.CLOSE_ARIA', { alias: 'aria-label' });
  readonly reason: InputSignal<string> = input<string>(ModalCloseReason.HEADER_BUTTON);
  readonly inputButtonBackground: InputSignal<IconButtonBackground> = input<IconButtonBackground>('dark-bg', { alias: 'buttonBackground' });
  readonly autoFocus: InputSignal<boolean> = input<boolean>(true);
  readonly onClose: OutputEmitterRef<void> = output<void>();

  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly defaultHeaderType: ModalHeaderType | null = inject(MODAL_HEADER_CONFIG, { optional: true });

  private readonly isLtMd: Signal<BreakpointState | undefined> = toSignal(this.mediaQueryService.observe(Breakpoint.LT_MD));

  readonly buttonBackground: Signal<IconButtonBackground> = computed((): IconButtonBackground => {
    if (this.defaultHeaderType === ModalHeaderType.LIGHT) {
      return this.isLtMd()?.matches ? 'clear-grey' : 'dark-bg';
    }
    return this.inputButtonBackground();
  });

  close(): void {
    this.onClose.emit();
  }
}
